import type {
  BridgeStepV2,
  BridgeTransferSpeedV2
} from '@injectivelabs/cctp-bridge'
import type { BridgeErrorFlow, BridgeErrorCategory } from './enums'
import type {
  BffDepositGetData,
  BFFProvidersGetData,
  BffWithdrawalGetData,
  BffWithdrawalPostData
} from './bff'

export const OnrampProvider = {
  Moonpay: 'moonpay',
  Coinbase: 'coinbase',
  BinanceConnect: 'binance-connect'
} as const

export type OnrampProvider =
  (typeof OnrampProvider)[keyof typeof OnrampProvider]

export type Deposit = BffDepositGetData[number]
export type Withdrawal = BffWithdrawalGetData[number]
export type WithdrawalFees = BffWithdrawalPostData['fees']
export type OnrampProviderWithStatus =
  BFFProvidersGetData['providersWithStatus'][number]

export interface QrDepositPollingError {
  message: string
  isDegraded: boolean
  failedAttempts: number
}

export interface CctpFeeItem {
  minimumFee: number
  finalityThreshold: number
}

export type BridgeErrorMapping = {
  key: string
  pattern: RegExp
  category: BridgeErrorCategory
}

export type ReportBridgeErrorParams = {
  error: unknown
  operation: string
  sessionId?: string
  sourceChain?: string
  flow: BridgeErrorFlow
  bridgeStep?: BridgeStepV2
  destinationChain?: string
  shouldReportWalletRejection?: boolean
  transferSpeed?: BridgeTransferSpeedV2
  continuedFromStep?: null | BridgeStepV2
}
